import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import {StatTitle, NumberBox} from './utils'
import {n} from 'shared/numbers'

class TotalSection extends React.Component{
  constructor(props){
    super(props)
    this.state={
      totalImpressions:0,
      totalReach:0
    }
  }
  componentDidMount(){
    this.loadStats(this.props)
  }
  componentWillReceiveProps(props){
    this.loadStats(props)
  }

  loadStats=(props)=>{
    let totalImpressions=0;
    let totalReach=0;
    props.stories.forEach(s=>{
      totalImpressions=totalImpressions+s.insights.impressions
      totalReach=totalReach+s.insights.reach
    })
    this.setState({totalImpressions, totalReach})
  }

  render(){
    return (
      <div className={cn(this.props.className, css.statsBox)}>
        <StatTitle>Totals</StatTitle>
        <div className={css.totalContainer}>
          <NumberBox className={css.generalBox} title="Impressions">{n(this.state.totalImpressions)}</NumberBox>
          <NumberBox className={css.generalBox} title="Reach" description="">{n(this.state.totalReach)}</NumberBox>
        </div>
      </div>
    )
  }
}

export default TotalSection;



// WEBPACK FOOTER //
// ./src/components/account_page/stats/sections/total.js